module.exports = __webpack_public_path__ + "static/media/copy.0b1913cf.svg";